/*
 * @Author: your name
 * @Date: 2021-12-12 10:28:16
 * @LastEditTime: 2021-12-14 14:31:30
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \dhr_frontend\src\routes\modules\humanResources.js
 */
export default [
  {
    name: "channelSetting",
    path: "/humanResources/channelSetting",
    component: () =>
      import("@/views/humanResources/channelSetting/channelSetting"),
    meta: {
      title: "渠道设置",
    },
  },
  {
    name: "channelBudget",
    path: "/humanResources/channelBudget",
    component: () =>
      import("@/views/humanResources/channelBudget/channelBudget"),
    meta: {
      title: "渠道预算",
    },
  },
  {
    name: "rcruitmentCost",
    path: "/humanResources/rcruitmentCost",
    component: () => import("@/views/humanResources/rcruitmentCost/index"),
    meta: {
      title: "猎头费用",
    },
  },
  {
    name: "talentRadar",
    path: "/humanResources/talentRadar",
    component: () => import("@/views/humanResources/talentRadar/index"),
    meta: {
      title: "人才雷达",
    },
    props: {
      tabConfig: [
        {
          label: "目标公司配置",
          key: "talentRadarTargetCompany",
        },
        {
          label: "高校地图配置",
          key: "talentRadarUniversitiesConfig",
        },
      ],
    },
    redirect: {
      name: "talentRadarTargetCompany",
    },
    children: [
      {
        name: "talentRadarTargetCompany",
        path: "targetCompany",
        component: () =>
          import("@/views/humanResources/talentRadar/targetCompanyList.vue"),
        meta: {
          title: "目标公司配置",
          parentAuth: "/humanResources/talentRadar",
        },
      },
      {
        name: "talentRadarUniversitiesConfig",
        path: "universitiesConfig",
        component: () =>
          import(
            "@/views/humanResources/talentRadar/universitiesConfigList.vue"
          ),
        meta: {
          title: "高校地图配置",
          parentAuth: "/humanResources/talentRadar",
        },
      },
    ],
  },
  {
    name: "talentRadarCompany",
    path: "/humanResources/talentRadarCompany/:companyId",
    component: () => import("@/views/humanResources/talentRadar/index"),
    meta: {
      title: "公司详情",
    },
    redirect: {
      name: "talentRadarTargetCompanyDepartment",
    },
    props: {
      tabConfig: [
        {
          label: "部门",
          key: "talentRadarTargetCompanyDepartment",
        },
        {
          label: "人员",
          key: "talentRadarTargetCompanyPersonnal",
        },
      ],
    },
    children: [
      {
        name: "talentRadarTargetCompanyDepartment",
        path: "targetCompanyDepartment",
        component: () =>
          import("@/views/humanResources/talentRadar/departmentList"),
        meta: {
          title: "目标公司配置-部门",
          parentAuth: "/humanResources/talentRadar",
        },
      },
      {
        name: "talentRadarTargetCompanyPersonnal",
        path: "targetCompanyPersonnel",
        component: () =>
          import("@/views/humanResources/talentRadar/personnalList"),
        meta: {
          title: "目标公司配置-人员",
          parentAuth: "/humanResources/talentRadar",
        },
      },
    ],
  },
];
